import Vue from "vue";
import errorMixin from "@/mixins/errorMixin";
export default Vue.extend({
    mixins: [errorMixin],
    props: {
        templateConfig: {}
    }
});
